import * as React from 'react';

import Waves from '../waves';
import { RoundButtonStyle } from './round';

interface Props {
  Icon?: React.ComponentType;
  onClick?: (e: React.MouseEvent) => void;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: (e: React.MouseEvent) => void;
  mood?: string;
  size?: string;
  diameter?: number | string;
  iconColor?: string;
  iconHeight?: number;
  backgroundColor?: string;
  borderWidth?: number;
  borderColor?: string;
  id?: string;
}

const RoundButtonComponent: React.FC<Props> = (props) => {
  const {
    Icon,
    onClick,
    onMouseEnter,
    onMouseLeave,
    mood = 'default',
    size,
    diameter,
    iconColor,
    iconHeight,
    backgroundColor,
    borderWidth,
    borderColor,
    id,
  } = props;

  return (
    <RoundButtonStyle
      {...{
        mood,
        size,
        diameter,
        iconColor,
        iconHeight,
        backgroundColor,
        borderWidth,
        borderColor,
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      id={id}
    >
      {Icon ? <Icon /> : null}
      <Waves color={mood === 'default' ? 'turquoise' : 'white'} />
    </RoundButtonStyle>
  );
};

export const RoundButton = React.memo(RoundButtonComponent);
